module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAAIdJREFUKBVj/A8EDGQAJjL0gLWwgEh7e3sGKysros04duwYA9jGL1++YNV0/fp1rOIg9WAbQba1t7ejKDp58iQDSEFAQACDubk5ihxInBEUOMbGxgxubm4okiDO6dOnGUxNTTHEd+3ahdtGDNVIAiAbyQ7VAdIoLCyM5APCTJB6cKgSVoqpAgCfsDAf+9NWRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/kids-mesa.png
// module id = 507
// module chunks = 0